module.exports = __webpack_public_path__ + "static/media/dicero_page_area01_img_en.f6c87f6f.png";